import {
  bookingSourceRequestSchema,
  hotelBookingSessionSchema,
  hotelCheckoutSchema,
  hotelGuestFormSchema,
  type BookingSourceRequest,
  type HotelGuestForm,
} from '@cione/contracts'
import type { HttpClient } from './http'

export function createHotelBookingApi(http: HttpClient) {
  const path = (id: string) => `/api/booking-sessions/${encodeURIComponent(id)}`
  // No write gets a transport retry key: after interruption, recover by GET before another action.
  const write = (id: string, action: string, body: unknown, method: 'POST' | 'PUT' = 'POST') =>
    http.request({
      method,
      path: `${path(id)}/${action}`,
      body,
      schema: hotelCheckoutSchema,
      timeoutMs: 35000,
    })
  return {
    create: (request: BookingSourceRequest) =>
      http.request({
        method: 'POST',
        path: '/api/booking-sessions',
        body: bookingSourceRequestSchema.parse(request),
        schema: hotelBookingSessionSchema,
      }),
    session: (id: string, signal?: AbortSignal) =>
      http.request({ method: 'GET', path: path(id), schema: hotelBookingSessionSchema, signal }),
    view: (id: string, signal?: AbortSignal) =>
      http.request({
        method: 'GET',
        path: `${path(id)}/hotel-checkout`,
        schema: hotelCheckoutSchema,
        signal,
      }),
    rates: (id: string, revision: number) =>
      write(id, 'hotel-rates', { expected_session_revision: revision }),
    select: (id: string, revision: number, ref: string) =>
      write(id, 'selection', { expected_session_revision: revision, candidate_ref: ref }, 'PUT'),
    details: (id: string, revision: number, details: HotelGuestForm) =>
      write(
        id,
        'details',
        { expected_session_revision: revision, details: hotelGuestFormSchema.parse(details) },
        'PUT',
      ),
    confirm: (id: string, revision: number) =>
      write(id, 'confirmation', { expected_session_revision: revision }),
    order: (id: string, revision: number, confirmation: string) =>
      write(id, 'orders', { expected_session_revision: revision, confirmation_id: confirmation }),
  }
}
